import Swiper from 'swiper/bundle';

import 'swiper/css/bundle';

const swiper = new Swiper('.treatment-slider', {
    loop: true,
    slidesPerView: 3,
    spaceBetween: 30,
    navigation: {
        nextEl: '.treatment-next',
        prevEl: '.treatment-prev',
    },
    pagination: {
        el: '.treatment-pagination',
    },
    autoplay: {
        delay: 3500,
        disableOnInteraction: false,
    },
    breakpoints: {
        320: {
            slidesPerView: 1.2,
            spaceBetween: 20
        },
        480: {
            slidesPerView: 1.5,
            spaceBetween: 15
        },
        640: {
            slidesPerView: 2,
            spaceBetween: 20
        },
        768: {
            slidesPerView: 2.5,
            spaceBetween: 25
        },
        1024: {
            slidesPerView: 3,
            spaceBetween: 30
        }
    }
});


